__webpack_require__.p = "https://partnership-mpos-frontend-prod.ackoassets.com/next_assets/2b5524c63d60a2c7630e1d2a3ea840acecadb8d2/_next/";